<template>
  <div class="about-page">
    <!-- 顶部Banner -->
    <section class="banner-section">
      <div class="banner-container">
        <img src="@/assets/img/about_us_banner.png" alt="关于我们" class="banner-image">
        <div class="banner-text">
          <h1>走进恒毅新</h1>
        </div>
      </div>
    </section>

    <!-- 第一部分：公司介绍 -->
    <section class="company-intro">
      <div class="container">
        <h2 class="section-title">公司介绍</h2>
        <div class="intro-content">
          <div class="intro-text">
            <p class="intro-description">
              恒毅新生物科技自 2017 年成立以来，始终深耕基因编辑领域，致力于为科研和产业客户提供高质量的一站式解决方案。公司服务覆盖基因编辑的全链条环节，包括核心载体制备、细胞模型构建、CRISPR 文库筛选，以及基因编辑有效性与安全性评估。凭借严谨的技术体系和丰富的实践经验，我们不断推动基因编辑在生命科学研究和新药研发中的深入应用。
            </p>
            <p class="intro-description">
              公司依托四大核心平台——NGS 高通量测序、荧光成像、ddPCR 数字 PCR 以及云数据分析，实现了从实验设计、数据采集到智能化解读的高效整合。我们秉承 "科学驱动，创新赋能" 的理念，致力于为生命科学基础研究、肿瘤学、免疫学、遗传学以及新药研发提供 可靠、高效的一站式科研服务。
            </p>
          </div>
          <div class="intro-image">
            <img src="@/assets/img/introduciton.png" alt="公司介绍" class="intro-img">
          </div>
        </div>
      </div>
    </section>

    <!-- 第二部分：1000平医学独立实验室 -->
    <section class="laboratory-section">
      <div class="container">
        <h2 class="section-title">1000平医学独立实验室</h2>
        <div class="lab-images">
          <img src="@/assets/img/about1.png" alt="实验室1" class="lab-img">
          <img src="@/assets/img/about2.png" alt="实验室2" class="lab-img">
        </div>
        <p class="lab-description">
          依据《生物安全实验室建筑技术规范》（GB 50346-2011）、《医学生物安全二级实验室建筑技术标准》(T-CECS 662-2020)等最新国家和行业标准进行设计建设，新增了临床免疫检验实验室，总建设面积1000平方。
        </p>
      </div>
    </section>

    <!-- 第三部分：技术平台 -->
    <section class="tech-platform">
      <div class="container">
        <h2 class="section-title">技术平台</h2>
        <div class="tech-image">
          <img src="@/assets/img/about3.png" alt="技术平台" class="tech-img">
        </div>
        <div class="tech-content">
          <div class="tech-item">
            <h3>01、肿瘤领域</h3>
            <p>各类癌种靶向用药检测;大Panel/中Panel/小Panel;肿瘤早筛。</p>
          </div>
          <div class="tech-item">
            <h3>02、遗传病领域</h3>
            <p>遗传病全外显子检测;神经系统、代谢系统和消化系统等遗传性疾病。</p>
          </div>
          <div class="tech-item">
            <h3>03、感染领域</h3>
            <p>呼吸道感染病毒细菌检测;肠道微生物多样性检测;生殖道感染病毒检测;宏基因组检测。</p>
          </div>
          <div class="tech-item">
            <h3>04、神经系统自身免疫病领域</h3>
            <p>如多发性硬化症(MS)、重症肌无力(MG)、抗NMDA受体脑炎等。</p>
          </div>
          <div class="tech-item">
            <h3>05、体检领域+慢病领域</h3>
            <p>肿瘤易感基因检测;皮肤美容易感基因检测;营养代谢检测;个人特质基因检测。<br>
            降压/降糖、降脂药、抗凝药、精神疾病用药检测。</p>
          </div>
          <div class="tech-item">
            <h3>06、科研服务</h3>
            <p>全基因组测序;全外显子组测序;转录组测序;宏基因组检测;数字PCR微小残留检测;拷贝数变异分析。</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 第四部分：云数据分析平台 -->
    <section class="cloud-platform">
      <div class="container">
        <h2 class="section-title">云数据分析平台的搭建和开发</h2>
        <div class="platform-images">
          <div class="platform-left">
            <img src="@/assets/img/platform5.png" alt="平台2" class="platform-img">
          </div>
          <div class="platform-right">
            <img src="@/assets/img/platform3.png" alt="平台3" class="platform-img-small">
            <img src="@/assets/img/platform4.png" alt="平台4" class="platform-img-small">
          </div>
        </div>
        <div class="platform-content">
          <p class="platform-description">
            恒毅新生物携手良培基因搭建云数据分析平台，该平台依托本地搭建的高性能计算集群系统，高达10TB的日数据处理能力，配备400TB存储能力，同时拓展阿里云服务器的支撑，助力快速分析解读。平台基于extflow框架整合遗传WES、CNV-seq、线粒体、病原检测等多产品自动化分析流程，多线程调度分析，并搭建自主开发的分析解读平台Primbio Cloud，实现从数据分析既参考最新临床指南，专业数据库，网站，权威书籍外，同时参考收录了几万份临床数据的自建数据库，自建报告解读线上系统，结果更加快捷准确，为临床医生诊疗提供参考。
          </p>
          
          <div class="join-us">
            <h3>加入我们</h3>
            <p>
              在恒毅新生物科技，我们相信人才是创新的核心驱动力。自 2017 年成立以来，公司始终以开放、协作和探索为文化基石，汇聚了一支由分子生物学、基因编辑、测序分析及数据科学等多领域专家组成的团队。我们期待与同样热爱科研、勇于创新的你携手，共同推动基因编辑技术的发展，助力生命科学与新药研发的未来。
            </p>
            <p>
              无论你是希望在 <strong>实验研发</strong> 中突破自我，还是在 <strong>数据分析、技术应用</strong> 上深耕积累，这里都能为你提供广阔的平台与发展空间。加入我们，你将有机会参与 <strong>前沿项目</strong>、接触 <strong>核心技术</strong>，与业内优秀人才一起实现科学价值与社会价值的双重提升。
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Home/Footer.vue'

export default {
  name: 'About',
  components: {
    Footer
  },
  data() {
    return {
      
    }
  }
}
</script>

<style lang="scss" scoped>
.about-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f8f9fa;
  padding: 6rem 0 0;
}

.container {
  max-width: 75rem;
  margin: 0 auto;
  padding: 0 1.25rem;
}

// Banner部分
.banner-section {
  width: 100%;
  position: relative;
  
  .banner-container {
    width: 100%;
    position: relative;
    overflow: hidden;
    
    .banner-image {
      width: 100%;
      height: auto;
      object-fit: cover;
      display: block;
    }
    
    .banner-text {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      z-index: 2;
      
      h1 {
        font-size: 4rem;
        font-weight: bold;
        color: white;
        text-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.5);
        margin: 0;
        letter-spacing: 0.2em;
        line-height: 1.2;
      }
    }
  }
}

// 通用样式
.section-title {
  font-size: 2.5rem;
  font-weight: bold;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 40px;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -0.625rem;
    left: 50%;
    transform: translateX(-50%);
    width: 5rem;
    height: 0.1875rem;
    background: linear-gradient(90deg, #3498db, #2ecc71);
  }
}

// 公司介绍部分
.company-intro {
  padding: 5rem 0;
  background: white;
  
  .section-title {
    margin-bottom: 3rem;
  }
  
  .intro-content {
    display: flex;
    align-items: flex-start;
    gap: 3.75rem;
    
    .intro-text {
      flex: 1;
      
      .intro-description {
        font-size: 1.1rem;
        line-height: 1.8;
        color: #555;
        margin-bottom: 1.25rem;
        text-align: justify;
      }
    }
    
    .intro-image {
      flex: 1;
      
      .intro-img {
        width: 100%;
        height: auto;
        border-radius: 0.625rem;
        box-shadow: 0 0.625rem 1.875rem rgba(0,0,0,0.1);
      }
    }
  }
}

// 实验室部分
.laboratory-section {
  padding: 5rem 0;
  background: #f8f9fa;
  
  .lab-images {
    display: flex;
    gap: 1.875rem;
    margin-bottom: 2.5rem;
    justify-content: center;
    
    .lab-img {
      width: 45%;
      height: 18.75rem;
      object-fit: cover;
      border-radius: 0.625rem;
      box-shadow: 0 0.3125rem 1.25rem rgba(0,0,0,0.1);
    }
  }
  
  .lab-description {
    font-size: 1.1rem;
    line-height: 1.8;
    color: #555;
    text-align: center;
    max-width: 50rem;
    margin: 0 auto;
  }
}

// 技术平台部分
.tech-platform {
  padding: 5rem 0;
  background: white;
  
  .tech-image {
    text-align: center;
    margin-bottom: 3.125rem;
    
    .tech-img {
      max-width: 100%;
      height: auto;
      border-radius: 0.625rem;
      box-shadow: 0 0.625rem 1.875rem rgba(0,0,0,0.1);
    }
  }
  
  .tech-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(21.875rem, 1fr));
    gap: 1.875rem;
    
    .tech-item {
      background: #f8f9fa;
      padding: 1.875rem;
      border-radius: 0.625rem;
      border-left: 0.25rem solid #5e7c85;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      
      &:hover {
        transform: translateY(-0.3125rem);
        box-shadow: 0 0.625rem 1.5625rem rgba(0,0,0,0.1);
      }
      
      h3 {
        font-size: 1.3rem;
        color: #2c3e50;
        margin-bottom: 0.9375rem;
        font-weight: bold;
      }
      
      p {
        font-size: 1rem;
        line-height: 1.6;
        color: #666;
      }
    }
  }
}

// 云数据分析平台部分
.cloud-platform {
  padding: 5rem 0;
  background: #f8f9fa;
  
  .platform-images {
    display: flex;
    gap: 1.875rem;
    margin-bottom: 3.125rem;
    align-items: stretch;
    
    .platform-left {
      flex: 1;
      
      .platform-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 0.625rem;
        box-shadow: 0 0.625rem 1.875rem rgba(0,0,0,0.1);
      }
    }
    
    .platform-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 1.25rem;
      
      .platform-img-small {
        width: 100%;
        height: calc(50% - 0.625rem);
        object-fit: cover;
        border-radius: 0.625rem;
        box-shadow: 0 0.3125rem 1.25rem rgba(0,0,0,0.1);
      }
    }
  }
  
  .platform-content {
    .platform-description {
      font-size: 1.1rem;
      line-height: 1.8;
      color: #555;
      margin-bottom: 4rem;
      text-align: justify;
    }
    
    .join-us {
      background: white;
      padding: 2rem;
      border-radius: 0.9375rem;
      box-shadow: 0 0.625rem 1.875rem rgba(0,0,0,0.1);
      
      h3 {
        font-size: 1.8rem;
        color: #2c3e50;
        margin-bottom: 1.25rem;
        text-align: center;
        font-weight: bold;
      }
      
      p {
        font-size: 1.1rem;
        line-height: 1.8;
        color: #555;
        margin-bottom: 0.9375rem;
        text-align: justify;
        
        strong {
          color: #3498db;
          font-weight: bold;
        }
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .container {
    padding: 0 0.9375rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .company-intro .intro-content {
    flex-direction: column;
    gap: 1.875rem;
  }
  
  .laboratory-section .lab-images {
    flex-direction: column;
    
    .lab-img {
      width: 100%;
    }
  }
  
  .tech-platform .tech-content {
    grid-template-columns: 1fr;
  }
  
  .cloud-platform .platform-images {
    flex-direction: column;
    
    .platform-left .platform-img {
      height: auto;
    }
    
    .platform-right .platform-img-small {
      height: auto;
    }
  }
  
  .banner-section .banner-text h1 {
    font-size: 2.5rem;
    letter-spacing: 0.1em;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 1.5rem;
  }
  
  .company-intro,
  .laboratory-section,
  .tech-platform,
  .cloud-platform {
    padding: 2.5rem 0;
  }
  
  .banner-section .banner-text h1 {
    font-size: 1.8rem;
    letter-spacing: 0.05em;
  }
}
</style>
